import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Mail } from "lucide-react";
import { Button } from "../../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../ui/dialog";
import { errDetail, settle } from "./settlementApi";

// Admin previews the one combined customer statement, then sends it (once per saved settlement).
export function SettlementEmailButton({ bookingId, groupId, label, testid }) {
  const [pv, setPv] = useState(null);
  const [busy, setBusy] = useState(false);
  const params = groupId ? { group_id: groupId } : { booking_id: bookingId };
  const open = async () => {
    setBusy(true);
    try { setPv(await settle.emailPreview(params)); } catch (e) { toast.error(errDetail(e).message); } finally { setBusy(false); }
  };
  const send = async () => {
    setBusy(true);
    try {
      const r = await settle.emailSend(params);
      toast.success(r.already_sent ? "Already sent for this settlement — not sent again" : `Sent to ${pv.to}`);
      setPv({ ...pv, already_sent: true });
    } catch (e) { toast.error(errDetail(e).message); } finally { setBusy(false); }
  };
  return (
    <>
      <Button variant="outline" size="sm" onClick={open} disabled={busy} className="text-[10px] uppercase tracking-wider border-[#9A7B4F]/30 text-[#9A7B4F]" data-testid={testid}>
        {busy && !pv ? <Loader2 className="w-3 h-3 animate-spin mr-1" /> : <Mail className="w-3 h-3 mr-1" />}{label}
      </Button>
      {pv && (
        <Dialog open onOpenChange={(o) => !o && setPv(null)}>
          <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="settlement-email-dialog">
            <DialogHeader><DialogTitle className="text-[15px]">{pv.subject}</DialogTitle></DialogHeader>
            <div className="text-[12px] text-[#676664]">To: <strong data-testid="settlement-email-to">{pv.to}</strong>{pv.already_sent && <span className="ml-2 text-emerald-700" data-testid="settlement-email-already-sent">· already sent{pv.sent_at ? ` ${new Date(pv.sent_at).toLocaleString("en-AU")}` : ""}</span>}</div>
            {!pv.email_key && <div className="text-[12px] text-amber-700" data-testid="settlement-email-not-ready">Save a settlement first — this is only a preview.</div>}
            <iframe title="Settlement email preview" srcDoc={pv.html} className="w-full h-[480px] border border-[#282828]/10 bg-white" data-testid="settlement-email-preview" />
            <div className="flex justify-end gap-2">
              <Button variant="outline" onClick={() => setPv(null)} data-testid="settlement-email-close-btn">Close</Button>
              <Button onClick={send} disabled={busy || pv.already_sent || !pv.email_key} className="bg-[#9A7B4F] hover:bg-[#8B6B3F] text-white" data-testid="settlement-email-send-btn">
                {busy && <Loader2 className="w-3 h-3 animate-spin mr-1" />}{pv.already_sent ? "Sent" : "Send to customer"}
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
